import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Chip, type ChipProps, Text, type TextProps } from "react-native-paper";
import type { IconType } from "../../types";

type Props = {
	children: React.ReactNode;
	textStyle?: object;
	iconColor?: string;
	textVariant?: TextProps<typeof Text>["variant"];
} & ChipProps;

const CustomChip = ({
	children,
	icon,
	textStyle = {},
	iconColor,
	textVariant = "labelSmall",
	...rest
}: Props) => (
	<Chip
		compact
		{...rest}
		icon={(props) =>
			icon ? (
				<Icon name={icon as IconType} {...props} color={iconColor} />
			) : null
		}
	>
		<Text
			style={{
				...textStyle,
			}}
			variant={textVariant}
		>
			{children}
		</Text>
	</Chip>
);

export default CustomChip;
